<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark to="/createDesignRequest">{{ $t('design_manager.create') }}</v-btn>
            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" class="elevation-1"
                  hide-default-footer :page.sync="page" :loading="loading" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" :item-class="this.$statusSale">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalDesignRequest }} </span> </span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2" v-if="!isAdmin && userCategory > 1">
              <v-autocomplete v-model="selectJobFilter" :items="jobFilters" item-text="title" dense return-object
                              outlined></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                  {{ item.sale.nickname }}
                </span>
        </div>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress" @click="showReportDialog(item)">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        <span class="text-no-wrap">{{ item.createdAt | formateDate }}</span>
      </template>

      <template v-slot:[`item.detail`]="{ item }">
        <div class="contentTitle">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
                info
              </v-icon>
            </template>
            <span>Thông tin chi tiết</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="resendEmail(item)">
                refresh
              </v-icon>
            </template>
            <span>Gửi lại email</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showEventDialog(item)">
                history
              </v-icon>
            </template>
            <span>Thông tin lịch sử</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.forward`]="{ item }">
        <v-btn color="primary" dark @click="sendToManufacture(item)">
          {{ $t('design_manager.forward') }}
        </v-btn>
      </template>

      <template v-slot:[`item.requestTitle`]="{ item }">
              <span class="contentTitle">
                {{ item.requestTitle + (item.orderUnit ? (' - ' + item.orderUnit.name) : '') }}
              </span>
      </template>

      <template v-slot:[`item.sendEmailStatus`]="{ item }">
        <span class="text-no-wrap linkText" v-if="item.sendEmailStatus === 1"> {{ $t('common.send_success') }} </span>
        <span class="text-no-wrap linkText" v-else-if="item.sendEmailStatus === 0"> {{ $t('common.send_fail') }} </span>
        <!-- <v-btn v-else color="primary" dark @click="resendEmail(item)">
          {{ $t('common.resend') }}
        </v-btn> -->
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
              <span class="contentName">
                {{ item.customer ? item.customer.fullname : 'Chưa có' }}
              </span>
      </template>

      <template v-slot:[`item.count_manufacture`]="{ item }">
              <span class="text-no-wrap">
                {{ item.count_manufacture }}
              </span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialogDetail" max-width="70%" v-if="editedItem">
      <v-card>
        <v-card-title>
          <span>Yêu cầu thiết kế: {{ editedItem.requestTitle + ' - ' + (editedItem.orderUnit ? editedItem.orderUnit.name : 'Không có') }}  </span>
          <v-spacer></v-spacer>
          <v-icon @click="dialogDetail=false">close</v-icon>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-container align="center">
            <v-row align="start">
              <v-col cols="12" sm="7">
                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.customer_infor') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }}
                  {{ editedDefaultAddress ? editedDefaultAddress.name : editedCustomer.fullname }}
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.phone') }}
                  {{ editedDefaultAddress ? editedDefaultAddress.phone : editedCustomer.phone }}
                </v-row>
                <v-row class="pb-1">
                  {{ $t('detail_request.facebook') }} <a :href="editedCustomer.facebook ? editedCustomer.facebook : ''"
                                                         target="_blank">
                  {{ editedCustomer.facebook ? editedCustomer.facebook : '' }} </a>
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.address') }}
                  {{ addressToString(editedCustomer.defaultAddress) }}
                </v-row>
                <v-row class="pb-4"> {{ $t('detail_request.customer_type') }} {{ editedCustomerType.name }}</v-row>

                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.email_content') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.number_estimate') }}
                  {{ thousandSeprator(editedItem.expected_number) }} chiếc
                </v-row>

                <v-row>Danh sách kiểu áo cần thiết kế:</v-row>

                <v-row v-for="(detail, index) in requestDetails" :key="detail._id">
                  <v-col cols="12" sm="1">
                    {{ index + 1 }}.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.form_style') }} {{ detail.formStyle.name }} <br/>
                    {{ $t('detail_request.material_style') }} {{ createMaterialStyleString(detail) }} <br/>
                    {{ $t('detail_request.note') }} {{ detail.note ? detail.note : '' }}
                  </v-col>
                </v-row>

                <v-row>Thông tin các mặt in:</v-row>
                <v-row>
                  <v-col cols="12" sm="1">
                    1.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.font') }}
                    <div v-html='editedItem.front_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ front_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.front_note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    2.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.behind') }}
                    <div v-html='editedItem.behind_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ behind_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.behind_note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    3.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.arm') }}
                    <div v-html='editedItem.arm_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ arm_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.arm_note }}</div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="5">
                <v-card>
                  <v-card-title> {{ $t('detail_request.image') }}</v-card-title>
                  <v-card-text>
                    <v-container align="center" justify="center">
                      <v-row align="center">
                        <v-col cols="12">
                          <span> {{ $t('design_item.front_side') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.front_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.behind') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.behind_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.arm') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.arm_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <report-dialog :dialog="reportDialog" @closeDialog="closeReport" :designRequest="editedItem"
                   :targetUser="selectedDesigner"></report-dialog>

    <event-log v-model="eventDialog" :editedItem="editedItem" :type="1" @closeDialog="closeEventDialog"
               v-if="editedItem">
    </event-log>

    <design-request-dialog v-model="dialogDetail" :editedItem="editedItem" @closeDialog="closeDetail" @update="updateItem" v-if="editedItem">
    </design-request-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import ReportDialog from "@/components/ReportDialog";
import EventLog from "@/components/EventLog";
import DesignRequestDialog from "@/components/DesignRequestDialog";
import socketClient from "@/plugins/socketClient";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    overlay: false,
    isSearching: false,

    isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
    userCategory: parseInt(localStorage.getItem('category')),
    userID: localStorage.getItem('user_id'),

    selectJobFilter: {},
    jobFilters: [
      {title: i18n.t('common.owner_job'), value: 0},
      {title: i18n.t('common.staff_job'), value: 1}
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    personalJobs: [],
    staffJobs: [],

    search: '',
    dialog: false,
    dialogDetail: false,
    eventDialog: false,

    reportDialog: false,
    headers: [],
    desserts: [],
    editedIndex: -1,
    editedItem: null,
    editedCustomer: {},
    editedCustomerType: {},
    editedDefaultAddress: {},

    front_image: null,
    behind_image: null,
    arm_image: null,

    front_printStyle: {},
    behind_printStyle: {},
    arm_printStyle: {},

    totalDesignRequest: 0,

    requestDetails: [],
    defaultItem: null,
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],
    selectedDesigner: {}
  }),

  components: {
    DesignRequestDialog: DesignRequestDialog,
    ReportDialog: ReportDialog,
    EventLog: EventLog
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('form_style.add') : i18n.t('form_style.edit')
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDetail(val) {
      val || this.closeDetail()
    },

    selectReadStatus() {
      this.filterData();
    },

    selectJobFilter() {
      if (this.selectJobFilter.value === 1) {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},

          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},

          {text: i18n.t('design_manager.count_manufacture'), sortable: false, value: 'count_manufacture'},
          {text: '', align: 'center', sortable: false, value: 'detail'},
          {text: '', value: 'forward', sortable: false},
          {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false}
        ]
      } else {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},

          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},

          {text: i18n.t('design_manager.count_manufacture'), sortable: false, value: 'count_manufacture'},
          {text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'detail'},
          {text: '', value: 'forward', sortable: false},
          {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false}
        ]
      }

      this.filterData();
    }
  },

  created() {
    if (this.isAdmin) {
      this.headers = [
        {text: '#', align: 'left', sortable: false, value: 'index',},
        {text: i18n.t('design_manager.code'), sortable: false, value: 'code'},
        {text: i18n.t('design_manager.name'), sortable: false, value: 'requestTitle'},
        // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
        {text: i18n.t('design_manager.date'), value: 'createdAt'},

        {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
        {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
        {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
        {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},

        {text: i18n.t('design_manager.count_manufacture'), sortable: false, value: 'count_manufacture'},
        {text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'detail'},
        {text: '', value: 'forward', sortable: false},
        {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false}
      ]
    } else {
      this.selectJobFilter = this.jobFilters[0];
    }

    this.getData();
    this.isSearching = true;
    const self = this;
    socketClient.getIO().on('UPDATE_DESIGN_REQUEST', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {
    },

    showDetail(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // this.editedCustomer = Object.assign({}, this.editedItem.customer)
      // this.editedCustomerType = item.customerType;
      // this.editedDefaultAddress = item.customer.defaultAddress;
      // this.requestDetails = this.editedItem.request_details;

      // this.front_image = this.baseImage + item.front_image;
      // this.behind_image = this.baseImage + item.behind_image;
      // this.arm_image = this.baseImage  + item.arm_image;

      // this.front_printStyle = item.front_printStyle;
      // this.behind_printStyle = item.behind_printStyle;
      // this.arm_printStyle = item.arm_printStyle;

      this.dialogDetail = true;
    },

    showEventDialog(item) {
      this.editedItem = Object.assign({}, item)
      this.eventDialog = true;
    },

    closeEventDialog(value) {
      this.eventDialog = value
      this.editedItem = null;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem(item) {
      const agree = confirm(i18n.t('common.confirm_delete'))
      if (agree) {
        const response = await this.$http.delete("/formStyle/" + item._id);
        if (response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);

          this.totalDesignRequest = this.desserts.length;
        }
      }
    },

    showReportDialog(item) {
      this.selectedDesigner = item.designer;
      this.editedItem = item;

      this.reportDialog = true;
    },

    closeReport(value) {
      this.reportDialog = value
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    closeDetail() {
      this.dialogDetail = false;
      this.editedItem = null;
    },

    async getData() {
      const self = this;
      self.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        // const response = await this.$http.get('/designRequest/by/me?' + "from=" + from + "&to=" + to);
        const response = await this.$http.get(process.env.VUE_APP_GET_DESIGN_REQUEST_CONTEXT_API + "?from=" + from + "&to=" + to);
        self.overlay = false;
        if (response.data && response.data.success) {
          self.personalJobs = [];
          self.staffJobs = [];
          self.readRequest = [];
          self.unreadRequest = [];

          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          self.desserts = contextArr;

          this.desserts.forEach(item => {
            const saler = item.sale;
            if (saler && saler._id === self.userID) {
              self.personalJobs.push(item);
            } else {
              self.staffJobs.push(item);
            }
          })
          self.filterData();

          this.totalDesignRequest = this.desserts.length;
          self.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async resendEmail(request) {
      const agree = confirm(i18n.t('common.confirm_resend_email'));
      if (!agree) {
        return;
      }

      try {
        console.log(request._id);
        const response = await this.$http.get('/designRequest/resend/' + request._id);
        if (response.data && response.data.success) {
          // console.log(response.data);
          this.$fire({
            title: i18n.t('common.resend_success'),
            text: "",
            type: "success"
          }).then(() => {
            // this.getData();
            request.sendEmailStatus = 1;
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterData() {
      if (this.selectJobFilter && this.selectJobFilter.value === 0) {
        this.desserts = [].concat(this.personalJobs);
      } else {
        this.desserts = [].concat(this.staffJobs);
      }

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => item.saleReadStatus == this.selectReadStatus.value));
      }

      this.totalDesignRequest = this.desserts.length;
    },

    addressToString(detail) {
      if (detail && detail.fullDetail) {
        return detail.fullDetail;
      } else {
        return '';
      }
    },

    createMaterialStyleString(detail) {
      if (!detail.materialStyle) {
        return '--';
      }
      return detail.materialStyle.material.name + " - " + detail.materialStyle.color_name +
          ' (' + detail.materialStyle.code + ')';
    },

    sendToManufacture(item) {
      this.$router.push({name: "createManufactureRequest", params: item});
    },

    thousandSeprator(amount) {
      if (!amount) {
        return 'Undefined';
      }

      if (amount !== '' || amount !== 0 || amount !== '0' || amount !== null) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return amount;
      }
    },

    updateItem(value) {
      Object.assign(this.desserts[this.editedIndex], value);
    },
  },
}
</script>

<style scoped>
vc-date-picker input {
  height: 300px;
}
</style>

